import { Injectable, Inject } from '@angular/core';

@Injectable()
export class ModalConfirmConfig {

    public modalSize: 'sm' | 'lg' = 'lg';
    public modalClass = '';
    public confirmBtnText = 'Confirm';
    public confirmBtnClass = 'btn btn-success';
    public cancelBtnText = 'Cancel';
    public cancelBtnClass = 'btn btn-danger';

    constructor(@Inject('ModalConfirmConfig') public options: any) {
        for (const option of Object.keys(options)) {
            this[option] = options[option];
        }
    }
}
